/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ detail: NonNullable<unknown> }} Cc_Embed_Error_Corrupt_InputInputs */



/**
* | output |
* | --- |
* | "The file appears to be damaged or incomplete: {detail}" |
*
* @param {Cc_Embed_Error_Corrupt_InputInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cc_embed_error_corrupt_input = /** @type {((inputs: Cc_Embed_Error_Corrupt_InputInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_Embed_Error_Corrupt_InputInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le fichier semble endommagé ou incomplet : ${i?.detail}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Datei scheint beschädigt oder unvollständig zu sein: ${i?.detail}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il file sembra essere danneggiato o incompleto: ${i?.detail}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Похоже, файл поврежден или неполный: ${i?.detail}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El archivo parece estar dañado o incompleto: ${i?.detail}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`文件似乎已损坏或不完整：${i?.detail}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ファイルが破損しているか、不完全なようです: ${i?.detail}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ़ाइल क्षतिग्रस्त या अपूर्ण प्रतीत होती है: ${i?.detail}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O arquivo parece estar danificado ou incompleto: ${i?.detail}`)
	return /** @type {LocalizedString} */ (`The file appears to be damaged or incomplete: ${i?.detail}`)
});